import { combineReducers } from 'redux';
import { onlineStore } from './onlineStore';
import { rentalProducts } from './rentalProducts';
import { utils } from './utils';

export default combineReducers({
    onlineStore,
    rentalProducts,
    utils
});